import React from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import { selectUser } from "../../components/auth/auth.selector";
import UnifiedPTDashboard from "../../components/unified-pt-view/UnifiedPTDashboard";
import "../../styles/unified-pt-view/unified-pt-view.css";

const UnifiedPTView = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: Unified PT View">
      <Container className="bg-cloud-k px-50px gobal-container unified-pt-view" fluid>
        <UnifiedPTDashboard userInfoData={userInfoData} />
      </Container>
    </HelmetWrapper>
  );
};

export default UnifiedPTView;
